import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_ENDPOINT } from '../../../_constants/endpoints';

const API_SUBSCRIBE = `${API_ENDPOINT}subscription`;

@Injectable({providedIn: 'root'})
export class SubscriptionService {
  constructor(private http: HttpClient) {
  }

  addPushSubscriber(payload) {
    return this.http.post<any>(`${API_SUBSCRIBE}`, payload);
  }

  updatePushSubscriber(payload) {
    return this.http.put<any>(`${API_SUBSCRIBE}`, payload);
  }

}
